import api from './api'

export default {
  show(adoptionId) {
    return api.get(`/partner-licensings/:partnerLicensingId/adoptions/${adoptionId}`)
  },
  revert(adoptionId) {
    return api.post(`/partner-licensings/:partnerLicensingId/adoptions/${adoptionId}/revert`)
  },
}
